var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.isBeforeEndOfSeptember
    ? _c("ModalDynamicContent", {
        ref: "modal",
        attrs: { "seen-promotions-property": "hp-junior-modal" },
        scopedSlots: _vm._u(
          [
            {
              key: "content",
              fn: function () {
                return [
                  _c(
                    "div",
                    { staticClass: "junior-modal-content-container" },
                    [
                      _c(
                        "h2",
                        {
                          staticClass: "text-h2",
                          attrs: { id: "junior-modal-title" },
                        },
                        [
                          _vm._v(
                            "\n        " +
                              _vm._s(_vm.$t("home_v3.junior_modal_header")) +
                              "\n      "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c("img", {
                        attrs: {
                          src: "/images/pages/home-v3/junior-modal-image.webp",
                          alt: _vm.$t("home_v3.junior_modal_header"),
                        },
                      }),
                      _vm._v(" "),
                      _c("p", { staticClass: "text-p" }, [
                        _vm._v(
                          "\n        " +
                            _vm._s(_vm.$t("home_v3.junior_modal_body")) +
                            "\n      "
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "CTAButton",
                        {
                          attrs: { href: _vm.href },
                          on: {
                            clickedCTA: function ($event) {
                              return _vm.onTryItNow()
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n        " +
                              _vm._s(_vm.$t("home_v3.try_it_now")) +
                              "\n      "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ]
              },
              proxy: true,
            },
          ],
          null,
          false,
          683664281
        ),
      })
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }